module.exports = __webpack_public_path__ + "static/media/ico-interesting-counter.f01a0f7e.svg";